import logos_idshield_color from './logos-idshield-color.svg';
import logos_legalshield_badge from './logos-legalshield-badge.svg';
import logos_legalshield_color from './logos-legalshield-color.svg';
import logos_pplsi from './logos-pplsi-mono.svg';
import logos_engage_color from './logos_engage_color.svg';
import logos_idshield from './logos_idshield.svg';
import logos_lawyer_connect_color from './logos_lawyer_connect_color.svg';
import logos_lawyer_connect_mono from './logos_lawyer_connect_monochrome.svg';
import logos_ls_ids from './logos_ls_ids.svg';
import logos_lsengage_color from './logos_lsengage_color.svg';
import logos_lshield from './logos_lshield.svg';
import logos_pplsi_mono from './logos_pplsi_monochrome.svg';
import logos_pplsi_ppl from './logos_pplsi_ppl.svg';
import logos_prospect_color from './logos_prospect_color.svg';
import logos_shield_at_work_color from './logos_shield_at_work_color.svg';
import logos_shield_at_work_mono from './logos_shield_at_work_monochrome.svg';

export const V2_LOGOS_ICONS: { [char: string]: string } = {
  logos_engage_color,
  logos_idshield,
  logos_idshield_color,
  logos_lawyer_connect_color,
  logos_lawyer_connect_mono,
  logos_legalshield_badge,
  logos_legalshield_color,
  logos_ls_ids,
  logos_lsengage_color,
  logos_lshield,
  logos_pplsi,
  logos_pplsi_mono,
  logos_pplsi_ppl,
  logos_prospect_color,
  logos_shield_at_work_color,
  logos_shield_at_work_mono,
};

export const V2_LOGOS_ICON_NAMES: string[] = Object.keys(V2_LOGOS_ICONS);
